import { _filtroTypeUtilsData } from "./filtroTypeUtilsData";
import { FiltroType } from "@/api";

export interface FiltroTypeHelper {
  label: string;
  icon: string;
}

const filtroTypesData: {
  [type in FiltroType]: typeof _filtroTypeUtilsData[keyof typeof _filtroTypeUtilsData];
} = {
  olio: _filtroTypeUtilsData.Olio,
  aria: _filtroTypeUtilsData.Aria,
} as const;

export interface FiltroTypeOption {
  value: FiltroType;
  label: string;
  icon: string;
}

export function getFiltroTypes(language?: string): FiltroTypeOption[] {
  const lang = (language || "it") as "it" | "de" | "en";
  return Object.entries(filtroTypesData).map(([value, data]) => ({
    value: value as FiltroType,
    label: data.Label[lang] || data.Label.it,
    icon: data.Icon,
  }));
}

export function getFiltroTypeHelper(type: FiltroType, language?: string): FiltroTypeHelper | null {
  // if (type === "unknown") {
  //   return null;
  // }
  const data = filtroTypesData[type];
  if (!data) {
    console.error("[FiltroTypeHelper] Unknown type: " + type);
    return null;
  }
  
  const lang = (language || "it") as "it" | "de" | "en";
  const label = data.Label[lang] || data.Label.it;
  
  return {
    label,
    icon: data.Icon,
  };
}
